import { ILayoutElement } from "../../_types/interfaces";

export const firstLinks: Array<ILayoutElement> = [
    {
        link: '/main',
        icon: 'i:account_balance',
        text: 'Главная страница',
    },
    {
        link: '/settings',
        icon: 'i:build',
        text: 'Настройки',
    },
    {
        link: '/secure',
        icon: 'i:shield',
        text: 'Лицензии',
    },
];